/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioDetails } from './PortfolioDetails';
import {
    PortfolioDetailsFromJSON,
    PortfolioDetailsFromJSONTyped,
    PortfolioDetailsToJSON,
    PortfolioDetailsToJSONTyped,
} from './PortfolioDetails';

/**
 * 
 * @export
 * @interface GetPortfolioListResponse
 */
export interface GetPortfolioListResponse {
    /**
     * 
     * @type {Array<PortfolioDetails>}
     * @memberof GetPortfolioListResponse
     */
    list?: Array<PortfolioDetails>;
}

/**
 * Check if a given object implements the GetPortfolioListResponse interface.
 */
export function instanceOfGetPortfolioListResponse(value: object): value is GetPortfolioListResponse {
    return true;
}

export function GetPortfolioListResponseFromJSON(json: any): GetPortfolioListResponse {
    return GetPortfolioListResponseFromJSONTyped(json, false);
}

export function GetPortfolioListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPortfolioListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'list': json['list'] == null ? undefined : ((json['list'] as Array<any>).map(PortfolioDetailsFromJSON)),
    };
}

export function GetPortfolioListResponseToJSON(json: any): GetPortfolioListResponse {
    return GetPortfolioListResponseToJSONTyped(json, false);
}

export function GetPortfolioListResponseToJSONTyped(value?: GetPortfolioListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'list': value['list'] == null ? undefined : ((value['list'] as Array<any>).map(PortfolioDetailsToJSON)),
    };
}

